<template>
  <div
    id="signin"
    class="d-flex justify-center">
    <v-form
      id="signin-form"
      @submit.prevent="signIn">
      <!-- User ID -->
      <v-text-field
        v-model="credentials.userEmailAddress"
        label="Email Address"
        :readonly="$store.getters.isLoadingActive">
      </v-text-field>
      <!-- / User ID -->

      <!-- Password -->
      <v-text-field
        v-model="credentials.password"
        label="Password"
        type="password"
        :readonly="$store.getters.isLoadingActive">
      </v-text-field>
      <!-- / Password -->

      <div class="d-flex mt-6">
        <!-- Sign In -->
        <v-btn
          class="flex-grow-1 mr-3"
          type="submit"
          color="primary"
          :loading="$store.getters.isLoadingActive"
          :disabled="$store.getters.isLoadingActive">
          Sign In
        </v-btn>
        <!-- / Sign In -->

        <!-- Sign In -->
        <v-btn
          class="flex-grow-1 ml-3"
          type="button"
          color="error"
          :loading="$store.getters.isLoadingActive"
          :disabled="$store.getters.isLoadingActive"
          @click="forgotPassword">
          Forgot Password
        </v-btn>
        <!-- / Sign In -->
      </div>
    </v-form>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'SignInPage',
  data() {
    return {
      credentials: {
        userEmailAddress: process.env.VUE_APP_USER_EMAIL || '',
        password: process.env.VUE_APP_PASSWORD || '',
      },
    };
  },
  methods: {
    signIn() {
      this.$store.dispatch(
        'signIn',
        { credentials: this.credentials },
      ).then(() => {
        const route = this.$store.state.referrer || { name: 'CallLogPage' };
        this.$store.dispatch('initialize');
        this.$router.push(route);
        this.$store.commit('clearAuthError');
      }, _.noop);
    },
    forgotPassword() {
      if (!this.credentials.userEmailAddress) {
        this.showWarning(
          'Please provide your Email Address in order to reset your password.',
          'Email Address',
        );
      } else {
        const confirm = () => {
          this.$store.dispatch('forgotPassword', {
            userEmailAddress: this.credentials.userEmailAddress,
          }).then(() => {
            this.showWarning(
              'Please check your Email Address for your temporary password. We recommend changing your password once you are able to sign in.',
              'Password Reset Successful',
            );
          });
        };

        this.showConfirm(
          'Are you sure you want to reset your password? If so, a temporary password will be sent to the email address you provide.',
          'Confirm Password Reset',
        ).then(confirm);
      }
    },
  },
};
</script>

<style lang="scss">
#signin {
  height: 100vh;

  #signin-form {
    margin-top: 15vh;
    width: 325px;

    #logo {
      display: block;
      width: 300px;
      margin: 0 auto 90px auto;
    }
  }
}
</style>
